import { render, staticRenderFns } from "./myDeliver.vue?vue&type=template&id=19add27e&scoped=true&"
import script from "./myDeliver.vue?vue&type=script&lang=js&"
export * from "./myDeliver.vue?vue&type=script&lang=js&"
import style0 from "./myDeliver.vue?vue&type=style&index=0&id=19add27e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19add27e",
  null
  
)

export default component.exports